import { Check } from "lucide-react";
import { Btn } from "./Btn";
import { Eyebrow, Words } from "./Typo";
import { Mascot, Script } from "./Script";
import { METHOD } from "../../lib/site";

export const spotMove = (e) => {
  const t = e.target.closest(".spot");
  if (!t) return;
  const r = t.getBoundingClientRect();
  t.style.setProperty("--mx", `${e.clientX - r.left}px`);
  t.style.setProperty("--my", `${e.clientY - r.top}px`);
};

export const CheckList = ({ items }) => (
  <ul className="checklist">{items.map((x) => <li key={x}><span><Check size={15} aria-hidden="true" /></span>{x}</li>)}</ul>
);

export const PageHero = ({ eyebrow, title, accent, lead, children, image, imageAlt, testid, visual, script, mascot }) => (
  <header className="page-hero" data-testid={testid}>
    <div className="aurora soft" aria-hidden="true" />
    <div className="page-hero-text">
      <Eyebrow>{eyebrow}</Eyebrow>
      <h1><Words text={title} />{accent && <><br /><Words text={accent} className="grad-text" /></>}</h1>
      {lead && <p className="lead" data-reveal>{lead}</p>}
      {children && <div className="actions" data-reveal>{children}</div>}
    </div>
    {visual && <div className="page-hero-custom" data-reveal>{visual}{script && <Script className="hero-script">{script}</Script>}</div>}
    {image && (
      <figure className="page-hero-visual">
        <img src={`/media/${image}-1264.webp`} srcSet={`/media/${image}-720.webp 720w, /media/${image}-1264.webp 1264w`}
          sizes="(max-width: 960px) 92vw, 46vw" width="1264" height="848" alt={imageAlt} loading="eager" fetchPriority="high" />
        {script && <Script className="hero-script">{script}</Script>}
        {mascot && <Mascot kind={mascot} className="hero-mascot" />}
      </figure>
    )}
  </header>
);

export const HeroAccent = ({ script, mascot = "main" }) => (
  <div className="hero-accent" aria-hidden="true"><Mascot kind={mascot} className="accent-mascot" /><Script className="accent-script">{script}</Script></div>
);

export const FinalCta = ({ audit = false }) => (
  <section className="final-cta" aria-labelledby="final-title" data-testid="final-cta">
    <img className="final-bg" src="/media/mountain-night-1264.webp" srcSet="/media/mountain-night-720.webp 720w, /media/mountain-night-1264.webp 1264w"
      sizes="100vw" width="1264" height="848" alt="" loading="lazy" decoding="async" />
    <div className="final-in">
      <h2 id="final-title" data-reveal>Prêt à passer au <span className="grad-text">niveau supérieur</span> ?</h2>
      <p className="lead" data-reveal>Discutons de votre projet et voyons ensemble comment NovaSoft peut vous aider à atteindre vos objectifs.</p>
      <div className="actions" data-reveal>
        <Btn to="/contact/" testid="final-cta-contact">Parler de mon projet</Btn>
        <Btn href="/#solutions" variant="ghost" testid="final-cta-solutions">Découvrir toutes nos solutions</Btn>
        {audit && <Btn to="/apercu-boutique/?type=audit" variant="ghost" testid="final-cta-audit">Obtenir mon audit offert</Btn>}
      </div>
      <Script className="final-script">A Brighter Tomorrow</Script>
    </div>
  </section>
);

export const MethodSteps = () => (
  <div className="method" data-testid="method-steps">
    {METHOD.map((s, i) => (
      <div className="method-step" key={s.title} data-reveal style={{ "--d": `${i * 80}ms` }}>
        <span>{s.n}</span><h3>{s.title}</h3><p>{s.desc}</p>
      </div>
    ))}
  </div>
);

export const CtaBand = ({ title, accent, text, children, testid = "cta-band" }) => (
  <section className="cta-band" data-testid={testid}>
    <div className="cta-glow" aria-hidden="true" />
    <h2 data-reveal>{title} <span className="grad-text">{accent}</span></h2>
    {text && <p className="lead" data-reveal>{text}</p>}
    <div className="actions" data-reveal>{children}</div>
  </section>
);

export const ContactCta = () => (
  <CtaBand title="Une idée ?" accent="On la rend concrète." text="Expliquez votre besoin. Nous vous aiderons à choisir la solution la plus utile.">
    <Btn to="/contact/" testid="cta-contact">Parler de mon projet</Btn>
    <Btn to="/apercu-boutique/" variant="ghost" testid="cta-apercu">Recevoir mon aperçu</Btn>
  </CtaBand>
);
